import { ChartTimelineIcon } from './ChartTimelineIcon';

/**
 * author: Austin Andrews
 * id 922A0C03-C46D-45E7-8B44-9D53F1292360
 * name chart-timeline
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-timeline.svg
 * tags
 * - Math 
 */
export const ReportTimelineIcon = ChartTimelineIcon;
export default ReportTimelineIcon